import { useQuery } from "react-query";
import { QueryKeys } from "../constants/QueryKeys";
import { useAxios } from "../hooks/useAxios";
// import { IResourceDataGrid } from 'interfaces/IResourceDataGrid';

type IPostType = {
  page: number;
  limit: number;
  category?: string | undefined;
};
export const useQueryGetPosts = (params: IPostType) => {
  // Get our Axios instance from the Hook
  const axios = useAxios();
  return useQuery(
    // return useQuery<IProjectsResponse, Error>(
    [QueryKeys.POSTS, params.page, params?.category],
    async () => {
      // Fetch data from the API using Axios.
      const { data } = await axios.get(`/posts`, { params });
      // Return the data from the Axios response
      return data;
    },
    {
      refetchOnWindowFocus: false,
    }
  );
};
